export enum EPatientDetailsItemLabel {
  gender = 'Gender',
  age = 'Age',
  dob = 'DOB',
  language = 'Language',
  bestAvailability = 'Best Availability',
  phone = 'Mobile phone',
}
